<script setup lang="ts">
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import misc404 from '@images/pages/404.png'
import miscMaskDark from '@images/pages/misc-mask-dark.png'
import miscMaskLight from '@images/pages/misc-mask-light.png'
import type { NuxtError } from 'nuxt/app'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  error: NuxtError
}>()

const authThemeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark)

const isDev = process.dev

const is404 = computed(() =>
  props.error?.statusCode === 404
  || Boolean(props.error?.message?.includes('404')),
)

const errToShow = computed(() => {
  if (is404.value) {
    return {
      title: 'Страница не найдена',
      description: 'Такого адреса нет в приложении. Проверьте ссылку или вернитесь на главную.',
    }
  }

  if (isDev) {
    return {
      title: props.error?.statusMessage || 'Ошибка',
      description: props.error.message,
    }
  }

  return {
    title: 'Что-то пошло не так',
    description: 'Мы уже разбираемся. Попробуйте обновить страницу чуть позже.',
  }
})

const handleError = () => {
  clearError({ redirect: '/' })
}
</script>

<template>
  <NuxtLayout name="blank">
    <div class="misc-wrapper">
      <ErrorHeader
        :status-code="props.error.statusCode"
        :title="errToShow.title"
        :description="errToShow.description"
      />

      <!-- eslint-disable vue/no-v-html -->
      <div
        v-if="isDev"
        style="max-inline-size: 80dvw; overflow-x: scroll;"
        v-html="props.error.stack"
      />
      <!-- eslint-enable -->

      <div class="d-flex flex-wrap justify-center gap-2 mb-11">
        <VBtn
          color="primary"
          class="text-none"
          @click="handleError"
        >
          На главную
        </VBtn>
        <VBtn
          variant="tonal"
          class="text-none"
          to="/admin-overview"
        >
          Админ-статистика
        </VBtn>
      </div>

      <div class="misc-avatar w-100 text-center">
        <VImg
          :src="misc404"
          alt="error 404"
          :max-height="$vuetify.display.smAndDown ? 350 : 500"
          class="mx-auto"
        />
      </div>

      <img
        class="misc-footer-img d-none d-md-block"
        :src="authThemeMask"
        alt="misc-footer-img"
        height="320"
      >
    </div>
  </NuxtLayout>
</template>

<style lang="scss">
@use "@core/scss/template/pages/misc.scss";
</style>
